import * as types from "../constants/actionTypes";

export const userLogin = login => {
  return {
    type: types.CLUB_USER_LOGIN,
    payload: login.data,
    msg: login.msg
  };
};

export const userLoginFailed = msg => {
  return {
    type: types.CLUB_USER_LOGIN_FAILED,
    msg: msg
  };
};

export const userLogout = () => {
  return {
    type: types.CLUB_USER_LOGOUT
  };
};

export const setDiscountClubConfig = discountClubConfig => {
  return {
    type: types.DISCOUNT_CLUB_CONFIG,
    payload: discountClubConfig
  };
};

export const setClubPricesInteresting = flag => {
  return {
    type: types.CLUB_PRICES_INTERESTING,
    payload: flag
  };
};



// WEBPACK FOOTER //
// ./src/actions/discountClubActions.js